import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';

@withI18next()
class BenefitPremiumComponent extends React.Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.benefits = [
      {
        title: t('credit_premium_benefit_member_title1'),
        description: t('credit_premium_benefit_member_content1', {
          service_type: Config.serviceType,
        }),
      },
      {
        title: t('credit_premium_benefit_member_title2'),
        description: t('credit_premium_benefit_member_content2', {
          service_type: Config.serviceType,
        }),
      },
      {
        title: t('credit_premium_benefit_member_title3'),
        description: t('credit_premium_benefit_member_content3', {
          service_type: Config.serviceType,
        }),
      },
      {
        title: t('credit_premium_benefit_member_title4'),
        description: t('credit_premium_benefit_member_content4', {
          service_type: Config.serviceType,
        }),
      },
      {
        title: t('credit_premium_benefit_member_title5'),
        description: t('credit_premium_benefit_member_content5', {
          service_type: Config.serviceType,
        }),
      },
      {
        title: t('credit_premium_benefit_member_title6'),
        description: t('credit_premium_benefit_member_content6', {
          service_type: Config.serviceType,
        }),
      },
      {
        title: t('credit_premium_benefit_member_title7'),
        description: t('credit_premium_benefit_member_content7', {
          service_type: Config.serviceType,
        }),
      },
      {
        title: t('credit_premium_benefit_member_title8'),
        description: t('credit_premium_benefit_member_content8', {
          service_type: Config.serviceType,
        }),
      },
      // {
      //   title: t('credit_premium_benefit_member_title9'),
      //   description: t('credit_premium_benefit_member_content9', {
      //     service_type: Config.serviceType,
      //   }),
      // },
      // {
      //   title: t('credit_premium_benefit_member_title10'),
      //   description: t('credit_premium_benefit_member_content10', {
      //     service_type: Config.serviceType,
      //   }),
      // },
      {
        title: t('credit_premium_benefit_member_title11'),
        description: t('credit_premium_benefit_member_content11', {
          service_type: Config.serviceType,
        }),
      },
    ];
  }

  render() {
    const { t, profile } = this.props;
    return (
      <div className={`benefit-premium bg-op2-${Config.serviceType}`}>
        <div className="container pt50 pb50">
          <h1
            className={`text-center font-weight-500 color-${Config.serviceType} pb10`}
          >
            {t('credit_premium_benefit_title')}
          </h1>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="list-benefits-premium">
              {this.benefits.map(({ title, description }, idx) => (
                <div key={idx} className="item-benefits-container">
                  <div
                    className={`item-benefits item-benefits-${idx + 1}-${
                      Config.serviceType
                    }`}
                  >
                    <h3
                      style={{ paddingTop: 65 }}
                      className={`color-${Config.serviceType}`}
                    >
                      {title}
                    </h3>
                    <p
                      className="benefit-description"
                      dangerouslySetInnerHTML={{
                        __html: description,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          {profile.role != Config.getRoles().PREMIUM && (
            <div className="text-center pt50">
              <button
                onClick={this.props.onRegisterPremium}
                className={`btn btn-ac-primary btn-${Config.serviceType} btn-join-premium`}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: t('credit_premium_benefit_button3'),
                  }}
                />
              </button>
            </div>
          )}
        </div>
        <style jsx global>
          {`
            .benefit-premium {
              margin-top: 70px;
            }

            .bg-op2-illust_ac {
              background-color: #efd2d7;
            }

            .bg-op2-photo_ac {
              background-color: #cbdfe5;
            }

            .benefit-premium .btn-join-premium {
              height: 48px;
              padding: 12px 20px;
              text-transform: uppercase;
              border-radius: ${Config.isIllustAC() ? '40px' : '4px'};
            }

            .benefit-premium .item-benefits > h3 {
              font-weight: 600;
            }

            .benefit-premium .list-benefits-premium {
              display: grid;
              grid-template-columns: 318px 318px 318px;
              grid-gap: 20px;
              width: 994px;
            }

            .benefit-premium .item-benefits-container {
              background: white;
              border-radius: 4px;
              overflow: hidden;
            }

            .benefit-premium .item-benefits {
              height: 318px;
              display: flex;
              align-items: center;
              flex-direction: column;
              justify-content: flex-start;
              padding: 15px;
              position: relative;
              background-position: center;
              background-repeat: no-repeat;
              background-size: cover;
            }

            .benefit-premium .benefit-description {
              font-size: 15px;
              overflow: auto;
            }

            .triangle-design_ac {
              width: 0;
              height: 0;
              border-top: 160px solid transparent;
              border-bottom: 160px solid transparent;
              border-left: 140px solid #ffead4;
              margin-left: -38px;
            }

            .item-benefits-1-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/01_design_ac.png);
            }

            .item-benefits-1-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/01_illust_ac.png);
            }

            .item-benefits-1-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/01_photo_ac.png);
            }

            .item-benefits-1-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/01_silhouette_ac.png);
            }

            .item-benefits-2-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/02_design_ac.png);
            }

            .item-benefits-2-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/02_illust_ac.png);
            }

            .item-benefits-2-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/02_photo_ac.png);
            }

            .item-benefits-2-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/02_silhouette_ac.png);
            }

            .item-benefits-3-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/03_design_ac.png);
            }

            .item-benefits-3-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/03_illust_ac.png);
            }

            .item-benefits-3-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/03_photo_ac.png);
            }

            .item-benefits-3-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/03_silhouette_ac.png);
            }

            .item-benefits-4-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/04_design_ac.png);
            }

            .item-benefits-4-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/04_illust_ac.png);
            }

            .item-benefits-4-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/04_photo_ac.png);
            }

            .item-benefits-4-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/04_silhouette_ac.png);
            }

            .item-benefits-5-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/05_design_ac.png);
            }

            .item-benefits-5-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/05_illust_ac.png);
            }

            .item-benefits-5-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/05_photo_ac.png);
            }

            .item-benefits-5-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/05_silhouette_ac.png);
            }

            .item-benefits-6-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/06_design_ac.png);
            }

            .item-benefits-6-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/06_illust_ac.png);
            }

            .item-benefits-6-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/06_photo_ac.png);
            }

            .item-benefits-6-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/06_silhouette_ac.png);
            }

            .item-benefits-7-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/07_design_ac.png);
            }

            .item-benefits-7-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/07_illust_ac.png);
            }

            .item-benefits-7-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/07_photo_ac.png);
            }

            .item-benefits-7-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/07_silhouette_ac.png);
            }

            .item-benefits-8-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/08_design_ac.png);
            }

            .item-benefits-8-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/08_illust_ac.png);
            }

            .item-benefits-8-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/08_photo_ac.png);
            }

            .item-benefits-8-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/08_silhouette_ac.png);
            }

            .item-benefits-9-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/09_design_ac.png);
            }

            .item-benefits-9-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/09_illust_ac.png);
            }

            .item-benefits-9-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/09_photo_ac.png);
            }

            .item-benefits-9-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/09_silhouette_ac.png);
            }

            .item-benefits-10-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/10_design_ac.png);
            }

            .item-benefits-10-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/10_illust_ac.png);
            }

            .item-benefits-10-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/10_photo_ac.png);
            }

            .item-benefits-10-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/10_silhouette_ac.png);
            }

            .item-benefits-11-design_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/11_design_ac.png);
            }

            .item-benefits-11-illust_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/11_illust_ac.png);
            }

            .item-benefits-11-photo_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/11_photo_ac.png);
            }

            .item-benefits-11-silhouette_ac {
              background-image: url(https://static.photo-ac.com/static/assets/image/premium/credit-card/11_silhouette_ac.png);
            }

            @media (max-width: 992px) {
              .benefit-premium .btn-join-premium {
                padding-left: 25px;
                padding-right: 25px;
              }
            }

            @media (min-width: 768px) and (max-width: 992px) {
              .benefit-premium .list-benefits-premium {
                grid-template-columns: calc(45% - 7px) calc(45% - 7px);
              }
            }

            @media (max-width: 767px) {
              .benefit-premium .list-benefits-premium {
                grid-template-columns: 318px;
                width: 318px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

export default BenefitPremiumComponent;
